import { render, staticRenderFns } from "./renYuan.vue?vue&type=template&id=71ebabc1&scoped=true"
import script from "./renYuan.vue?vue&type=script&lang=js"
export * from "./renYuan.vue?vue&type=script&lang=js"
import style0 from "./renYuan.vue?vue&type=style&index=0&id=71ebabc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ebabc1",
  null
  
)

export default component.exports